export const  routeLayerSettings= {
    routeLayerDefer: null,
    routeLayerPromise: null,
    activeRoutes: {
      styles: {
        clickedActive: {
          fillOpacity: 0.7,
          fillColor: '#4d7c28',
          fillColor: 'red',
          strokeColor: '#ffffff',
          strokeWeight: 1,
          strokeOpacity: 1,
          zIndex: -1,
        },
        hover: {
          fillOpacity: 0.5,
          strokeColor: '#c14900',
          zIndex: 30,
          strokeWeight: 5,
        },
        selected: {
          fillOpacity: 1,
          strokeColor: '#c14900',
          zIndex: 30,
          strokeWeight: 5,
        },
        defaultState: {
          fillOpacity: 1,
          strokeColor: '#c14900',
          strokeWeight: 4,
          zIndex: 30,
        },
      },
    },
    inactiveRoutes: {
      styles: {
        closed: {
          fillColor: '#2b2b2b',
          fillOpacity: 0.7,
        },
        partialClosed: {
          fillColor: '#006881',
          fillOpacity: 0.7,
        },
        fire: {
          fillColor: '#ef7b08',
          fillOpacity: 0.7,
        },
        visible: {
          zIndex: 1,
          fillOpacity: 1,
        },
        hidden: {
          zIndex: 0,
          fillOpacity: 0,
        },
        hover: {
          fillOpacity: 0.5,
          strokeColor: '#c14900',
          zIndex: 30,
          strokeWeight: 5,
        },
        selected: {
          fillOpacity: 1,
          strokeColor: '#c14900',
          zIndex: 30,
          strokeWeight: 5,
        },
        defaultState: {
          fillOpacity: 0.1,
          strokeColor: '#bcf57b',
          strokeWeight: 4,
          zIndex: 30,
        },
      },
    },
  };